export default {
    SMALL: 's',
    MEDIUM: 'm',
    LARGE: 'l'
};
